<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-if="isOnMobile"
      v-can="'representativesale.view'"
      class="item"
      effect="dark"
      content="Ez a bizonylat elérhető a képviselő mobilján"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-check"
        type="success"
        plain
        style="margin-left: 5px; cursor: help"
      />
    </el-tooltip>
    <el-tooltip
      v-if="!isOnMobile"
      v-can="'representativesale.view'"
      class="item"
      effect="dark"
      content="Bizonylat leküldése a képviselőnek 5 napra"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="loading"
        icon="el-icon-plus"
        style="margin-left: 5px;"
        @click="sendReceipt"
      />
    </el-tooltip>
    <el-tooltip
      v-if="representativeSale.nav_status === 'processing'"
      v-can="'representativesale.set_nav_status_to_success'"
      class="item"
      effect="dark"
      content="Már történt sikeres NAV szinkron"
      placement="top"
    >
      <el-button
        :loading="loading"
        size="mini"
        type="warning"
        icon="el-icon-check"
        style="margin-left: 5px;"
        @click="openSetNavStatusToSuccessDialog"
      />
    </el-tooltip>
  </div>
</template>

<script>
  import moment from 'moment'
  import getEnv from '../../../config/env.js'

  export default {
    props: ['representativeSale'],
    computed: {
      isOnMobile() {
        if (moment(this.representativeSale.created_at).isAfter(moment((new Date()).setHours(0,0,0,0)).subtract(getEnv('RECEIPT_HISTORY_INTERVAL_DAYS'), 'days'))) {
          return true;
        }
        if (this.representativeSale.is_available_on_mobile && moment(this.representativeSale.available_until_on_mobile).isAfter(moment())) {
          return true;
        }
        return false;
      }
    },
    data() {
      return {
        loading: false,
        deleteConfirmVisible: false,
      };
    },
    methods: {
      async sendReceipt() {
        this.loading = true;
        try {
          await axios.post(`api/representative-receipts/send-mobile/sale/${this.representativeSale.id}`)
          this.$store.dispatch('representativeSale/fetchAll');
        } catch (e) {

        }
        this.loading = false;
      },

      openSetNavStatusToSuccessDialog() {
        this.$confirm('Ez a folyamat nem visszafordítható, a számla NAV státusza "Elküldve" lesz.', 'Biztosan átállítja a státuszt? ', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.setNavStatusToSuccess();
        })
        .catch(() => {
          this.$router.replace('/representative-processes/representative-sales');
        });
      },

      async setNavStatusToSuccess() {
        this.loading = true;
        try {
          await this.$store.dispatch('representativeSale/setNavStatusToSuccess', this.representativeSale.id);
          this.$store.dispatch('representativeSale/fetchAll');
        } catch (e) {
          console.error(e)
        }
        this.loading = false;
      },
    }
  };
</script>
